import { ClientEmails } from '../../../components/form/ClientEmails';
import { ClientPhones } from '../../../components/form/ClientPhones';

interface ContactDetailsProps {
  onUpdateFormData?: (fieldName: string, fieldValue: unknown) => void;
}

export const ContactDetailsSection = ({ onUpdateFormData }: ContactDetailsProps) => {
  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 mt-4">
      <ClientEmails onUpdateFormData={onUpdateFormData} fieldPrefix='primary_passenger.client' />
      <ClientPhones onUpdateFormData={onUpdateFormData} fieldPrefix='primary_passenger.client'/>
    </div>
  );
};
